import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ArrowLeft, ChevronLeft, ChevronRight, FileDown, Download, Send, Save } from 'lucide-react';
import LanguageToggle from '../../components/LanguageToggle';
import { COMPANY } from '../../config/company';

const LeadDetailHeader = ({
  language,
  lead,
  prevLead,
  nextLead,
  currentLeadIndex,
  allLeads,
  navigateToLead,
  getLeadStatusBadge,
  generateWordDocument,
  generatePDF,
  handleEmailProposal,
  handleSave,
  generatingPdf,
  saving
}) => {
  return (
    <header className="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <nav className="container mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Link to="/admin?tab=pipeline">
              <Button variant="ghost" className="text-gray-600 hover:text-gray-900">
                <ArrowLeft className="mr-2 h-4 w-4" />
                {language === 'es' ? 'Pipeline' : 'Pipeline'}
              </Button>
            </Link>
            
            {/* Lead Navigation Arrows */}
            <div className="flex items-center border-l pl-2 ml-2">
              <Button 
                variant="ghost" 
                size="sm"
                onClick={() => navigateToLead(prevLead?.id)}
                disabled={!prevLead}
                className={`${!prevLead ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`}
                title={prevLead ? `${language === 'es' ? 'Anterior' : 'Previous'}: ${prevLead.client_name}` : ''}
              >
                <ChevronLeft className="h-5 w-5" />
              </Button>
              <span className="text-xs text-gray-400 mx-1">
                {currentLeadIndex + 1} / {allLeads.length}
              </span>
              <Button 
                variant="ghost" 
                size="sm"
                onClick={() => navigateToLead(nextLead?.id)}
                disabled={!nextLead}
                className={`${!nextLead ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`}
                title={nextLead ? `${language === 'es' ? 'Siguiente' : 'Next'}: ${nextLead.client_name}` : ''}
              >
                <ChevronRight className="h-5 w-5" />
              </Button>
            </div>
            
            <div className="border-l pl-3 ml-1">
              <h1 className="text-lg font-bold text-gray-900">{lead.client_name}</h1>
              <p style={{ color: COMPANY.primaryColor }} className="text-sm font-mono">
                {lead.proposal_id || lead.estimate_number}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <LanguageToggle />
            {getLeadStatusBadge(lead.lead_status)}
            <Button 
              onClick={generateWordDocument} 
              variant="outline" 
              className="border-blue-600 text-blue-600 hover:bg-blue-50" 
              disabled={generatingPdf}
            >
              <FileDown className="mr-2 h-4 w-4" />
              Word
            </Button>
            <Button 
              onClick={generatePDF} 
              variant="outline" 
              className="border-amber-600 text-amber-600 hover:bg-amber-50" 
              disabled={generatingPdf}
            >
              <Download className="mr-2 h-4 w-4" />
              PDF
            </Button>
            {lead.client_email && (
              <Button 
                onClick={handleEmailProposal}
                variant="outline"
                className="border-green-600 text-green-600 hover:bg-green-50"
                title={language === 'es' ? 'Enviar por Email' : 'Send via Email'}
              >
                <Send className="mr-2 h-4 w-4" />
                Email
              </Button>
            )}
            <Button 
              onClick={handleSave} 
              style={{ backgroundColor: COMPANY.primaryColor }} 
              className="text-white" 
              disabled={saving}
            >
              <Save className="mr-2 h-4 w-4" />
              {saving ? '...' : (language === 'es' ? 'Guardar' : 'Save')}
            </Button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default LeadDetailHeader;
